import { CellPosition, GridApi, NavigateToNextCellParams, RowDataTransaction } from '@ag-grid-community/core';
import { KEY_KEYS_CONSTANTS } from '@alk/core';

export function getSyncTransaction<T>(newValue: Array<T>, oldValue: Array<T>, keyProp: keyof T): RowDataTransaction {

    const toAdd = newValue.filter(newOrder => !oldValue.some(oldOrder => newOrder[ keyProp ] === oldOrder[ keyProp ]));
    const toUpdate = newValue.filter(newOrder => oldValue.some(oldOrder => newOrder[ keyProp ] === oldOrder[ keyProp ]));
    const toDelete = oldValue.filter(oldOrder => !newValue.some(newOrder => oldOrder[ keyProp ] === newOrder[ keyProp ]));

    return { add: toAdd, update: toUpdate, remove: toDelete } as RowDataTransaction;
}

export const navigateToNextCell = (gridApi: GridApi) =>
    (params: NavigateToNextCellParams): CellPosition => {
        const suggestedNextCell = params.nextCellPosition;
        if (params.key !== KEY_KEYS_CONSTANTS.UP_KEY &&
            params.key !== KEY_KEYS_CONSTANTS.DOWN_KEY &&
            params.key !== KEY_KEYS_CONSTANTS.LEFT_KEY &&
            params.key !== KEY_KEYS_CONSTANTS.RIGHT_KEY) {
            return suggestedNextCell;
        }

        if (Boolean(suggestedNextCell?.rowPinned)) {
            gridApi.deselectAll();
        } else {
            gridApi?.forEachNode((node) => {
                if (node.rowIndex === suggestedNextCell.rowIndex) {
                    node.setSelected(true);
                }
            });
        }
        return suggestedNextCell;
    };
